var map = {
	"./corbusier.png": "6754",
	"./handBlack.png": "7b88",
	"./handGray.png": "c738",
	"./handYellow.png": "0ac4",
	"./heart.png": "8d07",
	"./noheart - 複製.png": "6593",
	"./noheart.png": "fb3f",
	"./yellowHeart.png": "0921"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61f9";